import type React from 'react';
import type { SelectOption } from '@app/Utilities/SelectMap';
import { FormField } from './FormField';
import { SelectControl } from './Controls/SelectControl';
import { Button, ButtonProps, InputGroup } from 'react-bootstrap';

type SelectWithButtonFieldProps<TValue extends string | number> = {
  name: string;
  label: React.ReactNode;

  options: Array<SelectOption<TValue>>;
  className?: string;
  loading?: boolean;
  placeholder?: string;

  button: React.ReactNode;

  parse?: (raw: string) => TValue;
  disabled?: boolean;
};

export const SelectWithButtonField = <TValue extends string | number>({
  name,
  label,
  className,
  button,
  ...controlProps
}: SelectWithButtonFieldProps<TValue>) => {
  return (
    <FormField name={name} label={label} className={className}>
      <InputGroup>
        <SelectControl name={name} {...controlProps} />
        {button}
      </InputGroup>
    </FormField>
  );
};
